import React from "react";
import { useTranslation } from "react-i18next";
import { SwipeOption, VoteType } from "./utils/types";
import { formatDate, formatTime } from "./utils/dateUtils";

interface VoteSummaryProps {
  options: SwipeOption[];
  votes: Record<string, VoteType>;
  userHasVoted: Record<string, boolean>;
  getVoteText: (vote: VoteType) => string;
}

export const VoteSummary: React.FC<VoteSummaryProps> = ({
  options,
  votes,
  userHasVoted,
  getVoteText,
}) => {
  const { t } = useTranslation("polls");
  return (
    <div className="bg-muted rounded-2xl p-4 mb-6 border border-border">
      <h3 className="font-semibold text-foreground mb-3">
        {t("vote.summary.title")}
      </h3>
      <div className="space-y-2 text-sm max-h-40 overflow-y-auto pr-1">
        {options.map((option) => {
          const vote = votes[option.id];
          const hasVoted = !!vote;
          const voteLabel = getVoteText(vote);
          const voteColor =
            vote === "yes"
              ? "text-success"
              : vote === "no"
                ? "text-destructive"
                : "text-warning";

          // Afficher la date et le créneau horaire si disponible
          const dateText =
            option.date_group_label || formatDate(option.option_date);
          const timeText =
            option.time_slots && option.time_slots.length > 0
              ? formatTime(option.time_slots)
              : "";

          return (
            <div key={option.id} className="flex justify-between items-center">
              <span className="text-foreground">
                {dateText}
                {timeText ? ` • ${timeText}` : ""}
              </span>
              <span
                className={`font-medium ${hasVoted ? voteColor : "text-muted-foreground"}`}
              >
                {hasVoted ? voteLabel : t("vote.summary.notVotedYet")}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VoteSummary;
